import { render } from "./EstablishmentsCard.vue?vue&type=template&id=ecb18b08&scoped=true"
import script from "./EstablishmentsCard.vue?vue&type=script&lang=js"
export * from "./EstablishmentsCard.vue?vue&type=script&lang=js"

import "./EstablishmentsCard.vue?vue&type=style&index=0&id=ecb18b08&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb18b08"]])

export default __exports__